<script lang="ts" setup>
import { ref, watch } from "vue";

const emits = defineEmits(["changedPaging"]);

const props = defineProps({
  pageNumber: { type: Number, default: 1 },
  pageSize: { type: Number, default: 10 },
  pageCount: { type: Number, default: 1 },
});

const pageSizes = [
  { key: "5", value: 5 },
  { key: "10", value: 10 },
  { key: "25", value: 25 },
  { key: "50", value: 50 },
  { key: "Alles", value: -1 },
];

const selectedKey = ref(1);
const selectedPageNumber = ref(1);
const selectedPageSize = ref(10);
const selectedPageCount = ref(0);

watch(
  () => props.pageCount,
  (newValue) => {
    //console.log("GridPagination watch pageCount", newValue);
    selectedPageCount.value = newValue;
    selectedKey.value++;
  },
  { immediate: true }
);

watch(
  () => props.pageNumber,
  (newValue) => {
    //console.log("GridPagination watch pageNumber", newValue);
    selectedPageNumber.value = newValue;
  },
  { immediate: true }
);

watch(
  () => props.pageSize,
  (newValue) => {
    //console.log("GridPagination watch pageSize", newValue, selectedPageCount.value);
    selectedPageSize.value = newValue;
    selectedPageNumber.value = 1;
    selectedPageCount.value = selectedPageCount.value ? selectedPageCount.value : 0;
    selectedKey.value++;
  },
  { immediate: true }
);

function onPageNumberChange(newValue) {
  //console.log("GridPagination onPageNumberChange", newValue);
  // if (selectedPageNumber.value !== newValue) {
  //   selectedPageNumber.value = newValue;
  // }
  emits("changedPaging", { pageNumber: selectedPageNumber.value, pageSize: selectedPageSize.value });
}

function onPageSizeChange(newValue) {
  //console.log("GridPagination onPageSizeChange", newValue);

  //reset van v-pagination anders gaat callback update om een of andere reden niet goed, (page=2, size van 2 naar 4, blijven er maar twee zichtbaar??)
  selectedPageNumber.value = 1;
  //selectedPageCount.value = 0;
  //selectedPageSize.value = newValue;

  emits("changedPaging", { pageNumber: 1, pageSize: selectedPageSize.value });
}
</script>

<template>
  <v-container class="pa-0 pt-3">
    <v-row align="center" justify="center">
      <v-col cols="auto">
        <v-pagination v-model="selectedPageNumber" @update:modelValue="onPageNumberChange" :length="selectedPageCount" :total-visible="7" :key="selectedKey"> </v-pagination>
      </v-col>
      <v-col cols="auto"> Regels per pagina </v-col>
      <v-col cols="auto">
        <v-select v-model="selectedPageSize" @update:modelValue="onPageSizeChange" :items="pageSizes" item-title="key" item-value="value" density="compact" hide-details variant="solo"> </v-select>
      </v-col>
    </v-row>
  </v-container>
</template>
